/**
 *此处值定义消息总线常量
 * @author 籍龙波
 * */

/**
 *可以通过此渠道添加、移除、次改来电号码信息
 * */
export var COMING_CALL_INFO_CHANNEL = 'COMING_CALL_INFO_CHANNEL';